import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab-links"
export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.interceptTabClick()
  }

  // Wenn ein Tab geklickt wird, wird der Name des Tabs in der URL gespeichert
  // So kann wenn die Seite neu geladen wird, der Tab wieder geöffnet werden
  interceptTabClick() {
    this.tabTargets.forEach(tab => {
      tab.addEventListener('click', () => {
        const url = this.currentURL
        url.searchParams.set('view_part', tab.dataset.bsTarget.replace('#', ''))
        window.history.replaceState(history.state, "", url)
      })
    })
  }

  get currentURL() {
    return new URL(window.location);
  }
}
